import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vant from 'vant';
import './ajax/ajax'
import './plugins/bus'
import 'vant/lib/index.css';
import '@/styles/index.scss'
import store from './store/index.js'

Vue.use(Vant);
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
